/**
 * AskAsper-only build switch.
 *
 * This branch ships AskAsper as the only screen in the app: every other route is
 * dropped, the navbar carries no navigation, and login lands directly on AskAsper.
 * Flip ASK_ASPER_ONLY_MODE to false to restore the full multi-screen app.
 */
export const ASK_ASPER_ONLY_MODE = true;

/** Landing route used as home/fallback while ASK_ASPER_ONLY_MODE is on */
export const ASK_ASPER_HOME_ROUTE = '/ask-asper';
